export const STORIES_PROTRACK_FILTER_DEFAULT_ID = 'default'
export const STORIES_PROTRACK_FILTER_DEFAULT_VALUE = 'All ProTracks'
